import React from 'react'
import { Link } from 'react-router-dom'
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CHeaderToggler,
  CNavItem,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilBell, cilMenu, cilTask } from '@coreui/icons'

import { AppBreadcrumb } from './index'
import { AppHeaderDropdown } from './header/index'

import { useAppDispatch, useAppSelector } from '../redux/hooks'
import {
  selectSidebarShow,
  setValue as updateSidebarShow,
} from '../redux/features/sidebarShow/sidebarShowSlice'
import brandFull from '../assets/brand/brand-full.svg'
import UserHeaderDropdown from './header/UserHeaderDropdown'
import { selectCurrentUser } from '../redux/features/currentUser/currentUserSlice'
import LanguageDropdown from './header/LanguageDropdown'
import { _dictionary } from '../utils/translate'

const AppHeader = () => {
  const currentUser = useAppSelector(selectCurrentUser)
  const translate = _dictionary(currentUser?.active_language || null)
  const dispatch = useAppDispatch()
  const sidebarShow = useAppSelector(selectSidebarShow)

  return (
    <CHeader position="sticky" className="mb-4">
      <CContainer fluid>
        <CHeaderToggler className="ps-1" onClick={() => dispatch(updateSidebarShow(!sidebarShow))}>
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        {/*<CHeaderBrand className="mx-auto d-md-none" to="/">
          <img className="sidebar-brand-full" src={brandFull} alt={'ERP Solution'} />
        </CHeaderBrand>*/}
        <CHeaderNav className="d-none d-md-flex me-auto">
          <CNavItem>
            <Link to={'/'} className="nav-link">
              {translate('Dashboard')}
            </Link>
          </CNavItem>
          <CNavItem>
            <Link to={'/users'} className="nav-link">
              {translate('Users')}
            </Link>
          </CNavItem>
          <CNavItem>
            <Link to={'/settings'} className="nav-link">
              {translate('Settings')}
            </Link>
          </CNavItem>
        </CHeaderNav>
        <CHeaderNav>
          <CNavItem>
            <Link to={'/updates'} className="nav-link">
              <CIcon icon={cilBell} size="lg" />
            </Link>
          </CNavItem>
          <CNavItem>
            <Link to={'/tasks'} className="nav-link">
              <CIcon icon={cilTask} size="lg" />
            </Link>
          </CNavItem>
          <LanguageDropdown />
          {currentUser?.businessEntities?.data.length ? <UserHeaderDropdown /> : null}
        </CHeaderNav>
        <CHeaderNav className="ms-3">
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
      <CHeaderDivider />
      <CContainer fluid>
        <AppBreadcrumb />
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
